// extracted by mini-css-extract-plugin
module.exports = {"nomatch":"index_nomatch__2P7ow"};